import { createSelector } from 'reselect';
import heroSelector from 'selectors/heroSelector';
import selectedContentSelector from 'selectors/selectedContentSelector';
import { isEmpty } from 'lib/util';

/**
 * This selector determines which content should be used for the intial embed.
 * If there a piece of content is selected, use that, otherwise use the hero
 */
export default createSelector(
    heroSelector,
    selectedContentSelector,
    (hero, selectedContent) => {
        if (!isEmpty(selectedContent)) {
            return selectedContent;
        }
        return hero;
    }
);



// WEBPACK FOOTER //
// ./app/selectors/initialEmbedSelector.js